import React from 'react';

/**
 * <Text> + <Heading> primitives — UI-1 Phase 1.
 * Locked 6-step scale: display | h1 | h2 | body | micro | mono.
 */

const VARIANT_CLS = {
  display: 'text-[32px] leading-tight font-bold tracking-tight',
  h1:      'text-[24px] leading-snug font-semibold tracking-tight',
  h2:      'text-[18px] leading-snug font-semibold',
  body:    'text-[14px] leading-relaxed font-normal',
  micro:   'text-[12px] leading-normal font-medium',
  mono:    "text-[11px] font-semibold uppercase tracking-[0.12em] [font-family:var(--font-mono)]",
};

const TONE_CLS = {
  default:   'text-[color:var(--color-text-primary)]',
  secondary: 'text-[color:var(--color-text-secondary)]',
  muted:     'text-[color:var(--color-text-muted)]',
  primary:   'text-[color:var(--color-primary)]',
  success:   'text-[color:var(--color-success)]',
  warning:   'text-[color:var(--color-warning)]',
  danger:    'text-[color:var(--color-danger)]',
};

export function Text({
  children,
  variant = 'body',
  tone = 'default',
  as: As = 'span',
  className = '',
  ...rest
}) {
  return (
    <As className={`${VARIANT_CLS[variant] || VARIANT_CLS.body} ${TONE_CLS[tone] || TONE_CLS.default} ${className}`} {...rest}>
      {children}
    </As>
  );
}

export function Heading({
  children,
  level = 'h1',
  tone = 'default',
  className = '',
  as,
  ...rest
}) {
  const Tag = as || (level === 'display' ? 'h1' : level);
  return (
    <Tag className={`${VARIANT_CLS[level] || VARIANT_CLS.h1} ${TONE_CLS[tone] || TONE_CLS.default} ${className}`} {...rest}>
      {children}
    </Tag>
  );
}

export default Text;
